import {
  Box,
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableHead,
} from "@mui/material";
import FormSection from "../../../../common/components/functional/formSection/FormSection";
import { TextFieldLight } from "../../../../common/components/styled/styled";
import { useTranslation } from "react-i18next";
import { Union, UnionPayment } from "../unionsApi";
import { StyledTableCell, StyledTableRow } from "../unionsStyles";

interface Props {
  union: Union;
  setUnion: (union: Union) => void;
}

const UnionTermsOfPaymentList = ({ union, setUnion }: Props) => {
  const { t } = useTranslation();

  const handleChange = (value: string, year: number, property: string) => {
    // Create updated payments array
    const updatedPayments = union?.termsOfPayment?.payments?.map(
      (item: UnionPayment) => {
        if (item.year === year) {
          return {
            ...item,
            [property]: value,
          };
        } else {
          return item;
        }
      },
    );

    // Update union state with updated payments array
    setUnion({
      ...union,
      termsOfPayment: {
        ...union?.termsOfPayment,
        payments: updatedPayments,
      },
    });
  };

  const sortedPayments = [...(union?.termsOfPayment?.payments || [])].sort(
    (a, b) => (b?.year || 0) - (a?.year || 0),
  );

  return (
    <FormSection title={t("settings:unionTermsOfPayment")}>
      {union?.parentId && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginLeft: "20px",
          }}
        >
          <Box sx={{ whiteSpace: "nowrap" }}>
            {t("settings:overridePayments")}
          </Box>
          <Checkbox
            checked={union?.termsOfPayment?.overridePayments ?? false}
            onClick={() =>
              setUnion({
                ...union,
                termsOfPayment: {
                  ...(union?.termsOfPayment || {
                    overridePayments: false,
                    payments: [],
                  }),
                  overridePayments: !union.termsOfPayment?.overridePayments,
                },
              })
            }
          />
        </Box>
      )}
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4} />
        <Grid item xs={8}>
          <Table sx={{ width: "50%" }}>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>{t("settings:year")}</StyledTableCell>
                <StyledTableCell>
                  {t("settings:paymentPercentage")}
                </StyledTableCell>
                <StyledTableCell>{t("settings:fixedFee")}</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {sortedPayments.map((item, index) => {
                return (
                  <StyledTableRow key={index}>
                    <StyledTableCell>
                      <TextFieldLight
                        disabled={true}
                        value={item?.year || ""}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <TextFieldLight
                        disabled={
                          item?.fixedAmount && item?.fixedAmount !== ""
                            ? true
                            : false
                        }
                        value={item?.percentage || ""}
                        variant="outlined"
                        size="small"
                        fullWidth
                        onChange={(e) =>
                          (e.target.value === "" ||
                            /^[0-9][0-9.,]*$/.test(e.target.value)) && // Numbers, dots, or commas only
                          Number(e.target.value.replace(/,/g, ".")) <= 100 && // Max 100 %
                          handleChange(
                            e.target.value,
                            Number(item?.year),
                            "percentage",
                          )
                        }
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <TextFieldLight
                        disabled={
                          item?.percentage && item?.percentage !== ""
                            ? true
                            : false
                        }
                        value={item?.fixedAmount || ""}
                        variant="outlined"
                        size="small"
                        fullWidth
                        onChange={(e) =>
                          (e.target.value === "" ||
                            /^[0-9][0-9.,]*$/.test(e.target.value)) && // Numbers, dots, or commas only
                          e.target.value.length <= 10 && // Max 10 characters
                          handleChange(
                            e.target.value,
                            Number(item?.year),
                            "fixedAmount",
                          )
                        }
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </FormSection>
  );
};

export default UnionTermsOfPaymentList;
